import { computed, type ComputedRef } from 'vue'

export function useCourseIsUnavailableMessage(
    waitlistEnabled: ComputedRef<boolean>,
    selectedCourse: ComputedRef<{
        capacityResult: {
            isWaitlistFull: boolean
            overlappedBookedSessions: number
            contracts: number
        }
    } | null>
) {
    return computed(() => {
        if (selectedCourse.value === null) {
            return null
        }

        // If the asset schedule isn't allowing more sessions to be booked, return full
        if (selectedCourse.value.capacityResult.overlappedBookedSessions <= 0) {
            let message = 'You have selected a course that is full'

            if (waitlistEnabled.value) {
                if (selectedCourse.value.capacityResult.isWaitlistFull) {
                    message += '. The waitlist is currently full.'
                } else {
                    message += '. Join the waitlist below.'
                }
            }

            return message
        }

        // If remaining number of contracts allowed to be booked is 0
        if (selectedCourse.value.capacityResult.contracts <= 0) {
            let message = 'You have selected a course that is full'

            if (waitlistEnabled.value) {
                if (selectedCourse.value.capacityResult.isWaitlistFull) {
                    message += '. The waitlist is currently full.'
                } else {
                    message += '. Join the waitlist below.'
                }
            }

            return message
        }

        return null
    })
}
